import { combineReducers, configureStore, isPlain } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { Reducer } from 'redux';

import { rtkQueryApi } from './rtkQueryApi';

const reducers = {
  [rtkQueryApi.reducerPath]: rtkQueryApi.reducer,
};

export const combinedReducer = combineReducers<typeof reducers>(reducers);

export const rootReducer: Reducer<RootState> = (state, action) => {
  return combinedReducer(state, action);
};

// File downloads (reports, PDF exports) keep their bytes in the RTK Query mutation result
const isSerializable = (value: unknown) =>
  value instanceof Blob || value instanceof ArrayBuffer || isPlain(value);

export const setupStore = (preloadedState?: RootState) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: { isSerializable } }).concat(
        rtkQueryApi.middleware
      ),
    preloadedState,
  });

export const store = setupStore();

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof combinedReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;

export const useTypedDispatch = () => useDispatch<AppDispatch>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
